import mediator from "@tvg/mediator";
import { PlaceBetGtm, ConfirmBetErrorGtm, ConfirmBetSuccessGtm } from "./types";

export const confirmBetGtmEvent = ({
  raceNumber,
  trackName,
  betType,
  betAmount,
  selectionSource,
  raceType,
  module,
  specialWagerType
}: PlaceBetGtm) => {
  mediator.base.dispatch({
    type: "BET:BET_CONFIRM",
    payload: {
      module,
      raceNumber,
      trackName,
      betType,
      betAmount,
      selectionSource,
      raceType,
      specialWagerType
    }
  });
};

export const confirmBetErrorGtmEvent = ({
  error,
  raceNumber,
  trackName,
  selections,
  betAmount,
  runnerAmount,
  betType,
  module
}: ConfirmBetErrorGtm) => {
  mediator.base.dispatch({
    type: "BET:BET_ERROR",
    payload: {
      module,
      error,
      raceNumber,
      trackName,
      selections,
      betAmount,
      runnerAmount,
      betType
    }
  });
};

export const confirmBetSuccessGtmEvent = ({
  raceNumber,
  trackName,
  selections,
  betAmount,
  runnerAmount,
  repeatBet,
  betId,
  betType,
  selectionSource,
  raceType,
  module,
  specialWagerType,
  alternateSelectionApplied,
  alternateSelectionCount,
  betSettings,
  promoBet
}: ConfirmBetSuccessGtm) => {
  mediator.base.dispatch({
    type: "BET:BET_SUCCESS",
    payload: {
      module,
      raceNumber,
      trackName,
      selections,
      betAmount,
      runnerAmount,
      repeatBet,
      betId,
      betType,
      isRepeat: repeatBet ? "Repeat" : undefined,
      selectionSource,
      raceType,
      specialWagerType,
      alternateSelectionApplied,
      alternateSelectionCount,
      betSettings,
      promoBet
    }
  });
};
